export default "__VITE_ASSET__eee10a69__"